module.exports = __webpack_public_path__ + "static/media/slide.85347d51.png";